import {
  Col,
  Card,
  Input,
  CardBody,
  Row,
} from "reactstrap";
import { useEffect, useState } from "react";
import statusimage from "../../../assets/images/status.png";
import rightarrow from "../../../assets/images/chevron-right.png";
import download from "../../../assets/images/download.png";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import search from "../../../assets/images/search.png";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import "./DisbursedTable.css";
import PaginationTable from "../PaginationTable";
import { useSelector, useDispatch } from "react-redux";
import { Tooltip } from "@mui/material";
import { userActions } from "../../../actions/user.actions";
import InstituteAutocomplete from "../../status/ProjectTable/InstituteSearch";
import { ApplicationStatusEnum } from "../../../data";
import { handleExcelDownload } from "../../../utils/excelDownload";
import useDisbursedData from "../../../hooks/useDisbursedData";
import {Button} from "@mui/material";
import axiosInstance from "../../../helpers/axios";
import * as moment from "moment";
import { appContextConstants } from '../../../constants/appContext.constants';
import RefreshIcon from "@mui/icons-material/Refresh";
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import SourceBadge from "../../shared/SourceBadge/SourceBadge";
const DisbursedTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const datestate = useSelector((state) => state.Datefilter?.res);
  const usersearchdefstate = useSelector(
    (state) => state?.UserSearchDefault?.res?.data?.data
  );
  const usersearchinsstate = useSelector(
    (state) => state?.UserSearchIns?.res?.data?.data
  );

  const status = ApplicationStatusEnum.Disbursed;
  const decode = useCurrentUser();
  const user = null;

  const {
    tableData,
    productTypeSelected,
    currentPage,
    rowsPerPage,
    totalFetchRows,
    isLoading,
    filterDateFrom,
    filterDateTo,
    instituteId,
    instituteName,
    selectedChannel,
    activePage,
    isFilterApplied,

    setFilterDateFrom,
    setFilterDateTo,
    setInstituteId,
    setInstituteName,
    handlePageChange,
    handleRowsPerPageChange,
    handleSearch,
    clearFilters,
    handleChannelChange,
  } = useDisbursedData({
    status,
    user,
    dependencies: {
      datestate,
      usersearchdefstate,
      usersearchinsstate,
    },
  });
  useEffect(() => { window.addEventListener("beforeunload", () => sessionStorage.removeItem("disbursedTableFilters")); }, []);
  const [loading, setLoading] = useState(false)
  const [coappliantsSaveLoading, setCoapplicantSaveLoading] = useState(false)
  const [instituteResetKey, setInstituteResetKey] = useState(0);
  const valid = (current) => {
    if (!filterDateFrom) return true;
    return current.isAfter(filterDateFrom);
  };

  function formatNumberWithCommas(number) {
    return number.toLocaleString("en-IN");
  }

  const handleDownloadList = () => {
    handleExcelDownload({
      status: status,
      instituteId: decode.instituteId ? decode.instituteId : instituteId,
      fromDate: filterDateFrom,
      toDate: filterDateTo,
      productType:
        productTypeSelected && productTypeSelected !== "all"
          ? Number(productTypeSelected)
          : undefined,
      user: user,
      downloadIcon: download,
      buttonId: "downloadButton",
      buttonStyles: {
        width: "90px",
        marginLeft: "150px",
      },
      additionalData: {
        channel: selectedChannel,
      },
    });
  };

  const handleUser = (event) => {
    const Id = event.userId;
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: {
      userId: event.userId,
      coapplicantId: event?.coapplicantId
        ? typeof event?.coapplicantId === "string"
          ? event?.coapplicantId
          : event?.coapplicantId[0]
        : "",
      appId: event.applicationId,
    }});
    const getActivityUrl = `/audit?applicationId=${event.applicationId}`;
    dispatch(userActions.getActivity(getActivityUrl, user));
    navigate("/status/disbursed/profile", {
      state: {
        id: 1,
        profileId: Id,
        applicantId: Id,
        coapplicantId: event.coapplicantId,
        applicationId: event.applicationId,
        dir: "Disbursed",
      },
    });
  };

  const handleCoApp = (event) => {
    const Id = event.coapplicantId;
    const getActivityUrl = `/audit?applicationId=${event.applicationId}`;
    dispatch(userActions.getActivity(getActivityUrl, user));
    navigate("/status/disbursed/profile", {
      state: {
        id: 1,
        profileId: Id,
        clickEvent: "coapp",
        applicantId: event.userId,
        coapplicantId: event.coapplicantId,
        applicationId: event.applicationId,
        dir: "Disbursed",
      },
    });
  };

  const handleApplicationProfile = (
    currApplicationId,
    currUID,
    currCoAppId,
    item
  ) => {
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: {
      userId: currUID,
      appId: currApplicationId,
      coappId: currCoAppId,
    }});
    // const urlForApplicationDetails = `/admin/application/application-profile?applicationId=${sessionStorage.getItem(
    //   "appId"
    // )}`;
    // const urlForBankSelfie = `/integrations/application-profile?applicationId=${sessionStorage.getItem(
    //   "appId"
    // )}`;
    // const getEmiUrl = `/emis?applicationId=${sessionStorage.getItem("appId")}`;
    // const getActivityUrl = `/audit?applicationId=${sessionStorage.getItem(
    //   "appId"
    // )}`;
    // dispatch(
    //   userActions.fetchUrlforApplicationdetails(urlForApplicationDetails, user),
    //   []
    // );
    // dispatch(
    //   userActions.fetchUrlforbankselfie(urlForBankSelfie, user),
    //   []
    // );
    // dispatch(userActions.fetchEmiUrl(getEmiUrl, user), []);
    // dispatch(userActions.getActivity(getActivityUrl, user));
    navigate("/status/disbursed/appProfile", { state: item });
  };

  if (!tableData) {
    return <div>....Loading</div>;
  }

  const handlePushToFinsta = async () => {
    setLoading(true)
    try {
      const res = await axiosInstance.post('/bijay-routine/create-loans')
      if(res?.status===200){
        alert("Successful \nApplications sent to finsta")
      }
    } catch (error) {
      alert("Failed to create the loans")
    }finally{
      setLoading(false)
    }
  }

  const handleSaveCoapplicant = async () => {
    setCoapplicantSaveLoading(true)
    try {
      const res = await axiosInstance.post('/bijay-routine/create-coapplicants')
      if(res?.status===200){
        alert("Successful \nCo-Applicants sent to finsta")
      }
    } catch (error) {
      alert("Failed to save Co-applicants")
    }finally{
      setCoapplicantSaveLoading(false)
    }
  }

  return (
    <Card
      className="card"
      style={{
        width: "100%",
        height: "100%",
      }}
    >
        <CardBody>
          <div style={{display:'flex', justifyContent:'space-between'}}>
            <p style={{ display: "flex", alignItems: "center" }}>
              <img src={statusimage} alt="" />
              <span
                style={{
                  fontFamily: "Inter-Medium",
                  marginLeft: "10px",
                  fontSize: "14px",
                }}
              >
                status
              </span>
              <span style={{ marginLeft: "20px", marginBottom: "3px" }}>
                <img
                  style={{ height: "18px", width: "14px" }}
                  alt=""
                  src={rightarrow}
                />
              </span>
              <span
                style={{
                  fontFamily: "Inter-Medium",
                  marginLeft: "10px",
                  fontSize: "14px",
                  color: "#D32028",
                }}
              >
                Disbursed
              </span>
            </p>
            {decode?.clientId === "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" &&
              <div>
              <Button
                  variant="outlined"
                  onClick={handlePushToFinsta}
                  disabled={loading}
                  sx={{
                    color: '#416CC7',
                    textTransform: "none",
                    borderColor:'#AEBBD7',
                    ":hover":{
                      borderColor:'#AEBBD7',
                    },
                    ml:1,
                    minWidth:'120px'
                  }}>
                  {loading? 'Creating...' : 'Create Loans'}
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleSaveCoapplicant}
                  disabled={coappliantsSaveLoading}
                  sx={{
                    color: '#416CC7',
                    textTransform: "none",
                    borderColor:'#AEBBD7',
                    ":hover":{
                      borderColor:'#AEBBD7',
                    },
                    ml:1,
                    minWidth:'180px'
                  }}>
                  {coappliantsSaveLoading? 'Creating...' : 'Create Co-applicants'}
                </Button>       
              </div>
              }
          </div>
          <Row>
            <div style={{ display: "flex", flex: "wrap" }}>
              <Col sm="12" md="10" lg="3">
                <div
                  style={{
                    height: "23px",
                    marginTop: "7px",
                    marginRight: "10px",
                    fontFamily: "Inter",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {decode.role === "institute_admin" ||
                    decode.role === "institute_user" ||
                    decode.role === "institute_cra" ? (
                    <Input
                      type="text"
                      id="userSearch"
                      value={decode.instituteName}
                      readOnly
                      disabled
                      placeholder={"Merchant Name"}
                      style={{
                        fontSize: "0.8vw",
                        paddingLeft: "26px",
                        fontFamily: "Inter",
                        backgroundImage: `url(${search})`,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "5px center",
                        backgroundSize: "15px 15px",
                        paddingRight: "5px",
                        borderColor: "#cccccc",
                        borderStyle: "solid",
                        borderRadius: "5px",
                        borderWidth: "1px",
                        height: "34px",
                      }}
                    />
                  ) : (
                    <InstituteAutocomplete
                        key={instituteResetKey}
                      onInstituteSelect={(id,name) => {
                        setInstituteId(id)
                        setInstituteName(name || "");
                      }}
                      defaultValue={instituteName}
                      searchIcon={search}
                      placeholder={
                        decode?.clientId ===
                          "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361"
                          ? "Product Type"
                          : "Merchant Name"
                      }
                      marginTop={"12px"}
                    />
                  )}
                </div>
              </Col>
              <Col>
                <div style={{ height: "7px", marginRight: "10px" }}>
                  <Datetime
                    key={`fromDate-${filterDateFrom || "empty"}`}
                    closeOnSelect="false"
                    id="fromDate"
                    dateFormat="DD MMM YYYY"
                    timeFormat={false}
                    value={filterDateFrom ? moment(filterDateFrom, "DD MMM YYYY") : null}
                    onChange={(event) => {
                      if (event && event.format) {
                        setFilterDateFrom(event.format("DD MMM YYYY"));
                      } else {
                        setFilterDateFrom(null);
                        
                      }
                    }}
                    locale="en-gb"
                    inputProps={{
                      placeholder: "From Date",
                      style: { fontFamily: "Inter", fontSize: "14px" },
                    }}
                  />
                </div>
              </Col>
              <Col>
                <div style={{ height: "7px", marginRight: "10px" }}>
                  <Datetime
                    key={`toDate-${filterDateTo || "empty"}`}
                    closeOnSelect="false"
                    id="toDate"
                    dateFormat="DD MMM YYYY"
                    isValidDate={valid}
                    timeFormat={false}
                    locale="en-gb"
                    initialViewDate={
                      filterDateFrom
                        ? moment(filterDateFrom, 'DD MMM YYYY')
                        : moment()
                    }
                    onChange={(event) => {
                      if (event && event.format) {
                        setFilterDateTo(event.format("DD MMM YYYY"));
                      } else {
                        setFilterDateTo(null);
                       
                      }
                    }}
                    value={filterDateTo ? moment(filterDateTo, "DD MMM YYYY") : null}
                    inputProps={{
                      placeholder: "To Date",
                      style: { fontFamily: "Inter", fontSize: "14px" },
                    }}
                  />
                </div>
              </Col>
              {decode?.role === "institute_user" ||
                decode?.role === "institute_admin" ||
                decode.role === "channel_user" ? null : (
                <Col>
                  <div>
                    <select
                      id="column-select"
                      className="form-select"
                      onChange={(e) => handleChannelChange(e.target.value)}
                      value={selectedChannel}
                      style={{
                        fontSize: "0.8vw",
                        height: "34px",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "15px 15px",
                        borderColor: "#cccccc",
                        borderStyle: "solid",
                        borderRadius: "5px",
                        borderWidth: "1px",
                        cursor: "pointer",
                      }}
                    >
                      <option value="">Select CRA</option>
                      <option value="5">InsurFin</option>
                      <option value="6">QEC</option>
                    </select>
                  </div>
                </Col>
              )}

              <Col style={{ paddingLeft: "10px" }}>
                <div>
                  <button
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "130px",
                      backgroundColor: "#D22129",
                      height: "34px",
                      borderStyle: "none",
                      borderRadius: "5px",
                      color: "white",
                      fontFamily: "Inter",
                      paddingLeft: "10px",
                    }}
                    onClick={handleSearch}
                  >
                    Search Results
                  </button>
                </div>
              </Col>
              <Col>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <button
                    onClick={() => {
                      clearFilters();
                      setInstituteResetKey((prev) => prev + 1);
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "34px",
                      width: "42px",
                      backgroundColor: "#D22129",
                      border: "none",
                      borderRadius: "5px",
                      color: "white",
                      cursor: "pointer",
                      marginLeft:'10px'
                    }}
                  >
                    <RefreshIcon />
                  </button>
                </div>
              </Col>
              {decode.role === "cra" ||
                decode.role === "crsa" ||
                decode.role === "institute_cra" ||
                (decode.instituteId ===
                  "9d5eca4b-54f7-42a7-8794-1413e00b462e" &&
                  decode.role === "institute_user") ? null : (
                <Col>
                  <button
                    style={{
                      backgroundColor: "#D22129",
                      width: "90px",
                      height: "34px",
                      padding: "10px",
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "150px",
                      borderStyle: "none",
                      borderRadius: "5px",
                      color: "white",
                      fontFamily: "Inter",
                    }}
                    id="downloadButton"
                    onClick={handleDownloadList}
                  >
                    <p
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "15px",
                      }}
                    >
                      <img
                        style={{
                          height: "15px",
                          alignItems: "center",
                          marginRight: "5px",
                        }}
                        src={download}
                        alt="download"
                      />
                      <span>Export</span>
                    </p>
                  </button>
                </Col>
              )}
            </div>
          </Row>
          {isLoading ? (
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "15%",
                backgroundColor: "white",
                height: "100vh",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
              <div className="tables" style={{ marginTop: "20px" }}>
                <table hover>
                  <thead className="table-heading">
                    {/* --- your entire table header exactly as is --- */}
                    {/* I keep all header cells unchanged from your original */}
                    <tr>
                      <th
                        style={{
                          fontSize: "14px",
                          fontFamily: "Inter",
                          width: "5em",
                          borderTopLeftRadius: "8px",
                        }}
                        id="appId"
                      >
                        <span style={{ marginLeft: "10px" }}></span>Appl. Id
                      </th>
                      <th
                        id="appname"
                        style={{
                          fontSize: "14px",
                          fontFamily: "Inter",
                          width: "15%",
                        }}
                      >
                        <span style={{ marginLeft: "10px" }}>Appl. Name</span>
                      </th>
                      {(decode.role === "institute_user" ||
                        decode.role === "institute_admin" ||
                        decode.role === "channel_user") &&
                        (decode.instituteId ===
                          "0f25fafd-77c0-4c05-9cf1-1b238f5eebd3" ||
                          decode.instituteId ===
                          "9d5eca4b-54f7-42a7-8794-1413e00b462e") ? (
                        <th
                          style={{
                            fontSize: "14px",
                            fontFamily: "Inter",
                            width: "10em",
                          }}
                          id="appname"
                        >
                          <span style={{ marginLeft: "10px" }}></span> Student
                          Name
                        </th>
                      ) : null}
                      {decode.role === "institute_user" ||
                        decode.role === "institute_admin" ||
                        decode.role === "channel_user" ? null : (
                        <th
                          id="insName"
                          style={{
                            fontSize: "14px",
                            fontFamily: "Inter",
                            width: "15em",
                          }}
                        >
                          <span style={{ marginLeft: "10px" }}>
                            {decode?.clientId ===
                              "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361"
                              ? "Product Type"
                              : "Merchant Name"}
                          </span>
                        </th>
                      )}
                      <th id="amt" style={{ width: "10em" }}>
                        <span
                          style={{
                            fontSize: "14px",
                            fontFamily: "Inter",
                            marginLeft: "10px",
                          }}
                        >
                          Amount
                        </span>
                      </th>
                      {(decode.role === "institute_user" &&
                        decode.instituteId !==
                        "9d5eca4b-54f7-42a7-8794-1413e00b462e") ||
                        decode.role === "institute_admin" ||
                        decode.role === "channel_user" ? (
                        <th id="amt" title="Subvention Amount">
                          <span style={{ marginLeft: "10px" }}>SV</span>
                        </th>
                      ) : null}
                      {decode.instituteId ===
                        "1a62ed6b-a5f5-4ab3-acfa-6e353b070149" ? (
                        <th id="amt" title="Processing Fee Amount">
                          <span style={{ marginLeft: "20px" }}>PF</span>
                        </th>
                      ) : null}
                      <th id="pfAmount" style={{ width: "4em" }}>
                        <span
                          style={{
                            marginLeft: "15px",
                            fontSize: "14px",
                            fontFamily: "Inter",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Disbursed Dt.
                        </span>
                      </th>
                      {decode.instituteId ===
                        "9d5eca4b-54f7-42a7-8794-1413e00b462e" &&
                        decode.role === "institute_user" ? null : (
                        <th id="disbursedAmount" style={{ width: "4em" }}>
                          <span
                            style={{
                              fontSize: "14px",
                              fontFamily: "Inter",
                              marginLeft: "20px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Disbursed Amt
                          </span>
                        </th>
                      )}
                      <th
                        id="tenure"
                        style={{ textAlign: "center", width: "10em" }}
                      >
                        <span
                          style={{
                            marginLeft: "10px",
                            fontSize: "14px",
                            fontFamily: "Inter",
                          }}
                        >
                          Tenure
                        </span>
                      </th>
                      {decode.role === "institute_user" ||
                        decode.role === "institute_admin" ||
                        decode.role === "channel_user" ? null : (
                        <th
                          id="insName"
                          style={{
                            fontSize: "14px",
                            fontFamily: "Inter",
                            width: "5em",
                          }}
                        >
                          <span style={{ marginLeft: "10px" }}>
                            Fund Src.
                          </span>
                        </th>
                      )}
                      {decode.role === "institute_user" ||
                        decode.role === "institute_admin" ||
                        decode.role === "channel_user" ? (
                        <th
                          style={{
                            textAlign: "center",
                            width: "5em",
                            borderTopRightRadius: "8px",
                          }}
                        >
                          <span
                            style={{
                              marginRight: "10px",
                              fontSize: "14px",
                              fontFamily: "Inter",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Emi First Date
                          </span>
                        </th>
                      ) : null}
                      {decode.role === "institute_user" ||
                        decode.role === "institute_admin" ||
                        decode.role === "channel_user" ? (
                        <th
                          style={{
                            textAlign: "center",
                            width: "1em",
                            borderTopRightRadius: "8px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "14px",
                              fontFamily: "Inter",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Emi Amount
                          </span>
                        </th>
                      ) : null}
                      <th
                        id="utr"
                        style={{
                          textAlign: "center",
                          width: "10em",
                          borderTopRightRadius: "8px",
                        }}
                      >
                        <span
                          style={{
                            marginRight: "50px",
                            fontSize: "14px",
                            fontFamily: "Inter",
                          }}
                        >
                          UTR
                        </span>
                      </th>
                      {decode.role === "institute_user" ||
                        decode.role === "institute_admin" ||
                        decode.role === "channel_user" ? null : (
                        <th
                          id="utr"
                          style={{
                            textAlign: "center",
                            width: "9em",
                            borderTopRightRadius: "8px",
                          }}
                        >
                          <span
                            style={{
                              marginRight: "50px",
                              fontSize: "14px",
                              fontFamily: "Inter",
                            }}
                          >
                            CRA
                          </span>
                        </th>
                      )}
                    </tr>
                  </thead>
                  {tableData.map((item) => (
                    <tbody
                      className="table-body"
                      key={item.applicationId}
                    >
                      <tr
                        className="table-row"
                        style={{ lineHeight: "20px" }}
                      >
                        {decode.role !== "institute_user" &&
                          decode.role !== "institute_admin" &&
                          decode.role !== "channel_user" ? (
                          <td
                            style={{ width: "8em", fontFamily: "Inter" }}
                          >
                            <span
                              onClick={() =>
                                handleApplicationProfile(
                                  item.applicationId,
                                  item.userId,
                                  item.coapplicantId,
                                  item
                                )
                              }
                              style={{
                                cursor: "pointer",
                                fontSize: "14px",
                                fontWeight: "500",
                                fontFamily: "Inter",
                                width: "8em",
                                color: "#667085",
                                display: "inline-block",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {item.applicationId}
                            </span>
                          </td>
                        ) : (
                          <td
                            style={{ width: "5em", fontFamily: "Inter",color: '#667085' }}
                          >
                            <span
                              style={{
                                fontSize: "14px",
                                fontWeight: "400",
                                width: "5em",
                                fontFamily: "Inter",color: '#667085'
                              }}
                            >
                              {decode.role === "institute_user" &&
                                decode.instituteId ===
                                "9d5eca4b-54f7-42a7-8794-1413e00b462e" ? (
                                <Tooltip
                                  title={
                                    item.studentId
                                      ? item.studentId
                                      : "No StudentId"
                                  }
                                  arrow
                                >
                                  {item.applicationId}
                                </Tooltip>
                              ) : (
                                <>
                                  {item.orderId
                                    ? item.orderId
                                    : item.applicationId}
                                </>
                              )}
                            </span>
                          </td>
                        )}

                        {/* Applicant / Co-applicant Name */}
                        {decode.role === "institute_user" ||
                          decode.role === "institute_admin" ||
                          decode.role === "channel_user" ? (
                          <td
                            style={{
                              fontSize: "14px",
                              color: "#667085",
                              fontFamily: "Inter",
                            }}
                          >
                            <span
                              title={item.name}
                              style={{
                                maxWidth: "10em",
                                fontFamily: "Inter",
                                lineHeight: "1.5em",
                                display: "inline-block",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",color: '#667085'
                              }}
                            >
                              {item?.name
                                ?.toLowerCase()
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1)
                                )
                                .join(" ")}
                            </span>
                            <br />
                            {item.coapplicantName ? (
                              <span
                                title={item.coapplicantName}
                                style={{
                                  maxWidth: "10em",
                                  fontFamily: "Inter",
                                  lineHeight: "2em",
                                  display: "inline-block",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",color: '#667085'
                                }}
                              >
                                {item?.coapplicantName
                                  ?.toLowerCase()
                                  .split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1)
                                  )
                                  .join(" ")}{" "}
                                ( C )
                              </span>
                            ) : (
                              ""
                            )}
                          </td>
                        ) : (
                          <td
                            style={{
                              fontSize: "14px",
                              color: "#667085",
                              cursor: "pointer",
                              fontFamily: "Inter",
                            }}
                          >
                            <span
                              title={item.name}
                              style={{
                                width: "10em",
                                fontFamily: "Inter",
                                lineHeight: "1.5em",
                                display: "inline-block",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                              onClick={() => handleUser(item)}
                            >
                              {item?.name
                                ?.toLowerCase()
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1)
                                )
                                .join(" ")}
                            </span>
                            <br />
                            {item.coapplicantName ? (
                              <span
                                title={item.coapplicantName}
                                style={{
                                  width: "10em",
                                  fontFamily: "Inter",
                                  lineHeight: "2em",
                                  display: "inline-block",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",color: '#667085'
                                }}
                                onClick={() => handleCoApp(item)}
                              >
                                {item?.coapplicantName
                                  ?.toLowerCase()
                                  .split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1)
                                  )
                                  .join(" ")}{" "}
                                ( C )
                              </span>
                            ) : (
                              ""
                            )}
                          </td>
                        )}

                        {/* Student Name for a couple institutes */}
                        {(decode.role === "institute_user" ||
                          decode.role === "institute_admin" ||
                          decode.role === "channel_user") &&
                          (decode.instituteId ===
                            "0f25fafd-77c0-4c05-9cf1-1b238f5eebd3" ||
                            decode.instituteId ===
                            "9d5eca4b-54f7-42a7-8794-1413e00b462e") ? (
                          <td title={item.studentName}>
                            <span
                              style={{
                                width: "10em",
                                fontWeight: "400",
                                fontSize: "14px",
                                color: "#667085",
                                fontFamily: "Inter",
                                display: "block",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {item.studentName ? item.studentName : "-"}
                            </span>
                          </td>
                        ) : null}

                        {/* Merchant name */}
                        {decode.role === "institute_user" ||
                          decode.role === "institute_admin" ||
                          decode.role === "channel_user" ? null : (
                          <td>
                            <div className="merchant-with-source">
                              <span
                                title={item.instituteName}
                                style={{
                                  fontSize: "14px",
                                  maxWidth: "10em",
                                  color: "#667085",
                                  fontFamily: "Inter",
                                  display: "inline-block",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {item.instituteName
                                  ? item.instituteName
                                  : "-"}
                              </span>
                              {item.productType === 2 && (
                                <SourceBadge attribution={item.attribution} repeat={item.repeat} />
                              )}
                            </div>
                          </td>
                        )}

                        {/* Amount */}
                        <td>
                          <span
                            style={{
                              fontSize: "14px",
                              width: "5.5em",
                              textAlign: "center",
                              color: "#667085",
                              fontFamily: "Inter",
                            }}
                          >
                            {item.amount ? (
                              <>
                                &#8377;
                                {formatNumberWithCommas(item.amount)}
                              </>
                            ) : (
                              "-"
                            )}
                          </span>
                        </td>

                        {/* SV */}
                        {(decode.role === "institute_user" &&
                          decode.instituteId !==
                          "9d5eca4b-54f7-42a7-8794-1413e00b462e") ||
                          decode.role === "institute_admin" ||
                          decode.role === "channel_user" ? (
                          <td
                            style={{
                              fontSize: "14px",
                              width: "4em",
                              textAlign: "center",
                              color: "#667085",
                              fontFamily: "Inter",
                            }}
                          >
                            {Math.round(item.subventionAmount)}
                          </td>
                        ) : null}

                        {/* PF */}
                        {decode.instituteId ===
                          "1a62ed6b-a5f5-4ab3-acfa-6e353b070149" ? (
                          <td
                            style={{
                              fontSize: "14px",
                              width: "4em",
                              textAlign: "center",
                              color: "#667085",
                              fontFamily: "Inter",
                            }}
                          >
                            {Math.round(item.processingFee)}
                          </td>
                        ) : null}

                        {/* Disbursement date */}
                        <td
                          style={{
                            fontSize: "14px",
                            width: "4em",
                            textAlign: "center",
                            fontFamily: "Inter",
                            color: "#667085",
                          }}
                        >
                          {item.disbursementDate
                            ? item.disbursementDate
                            : "-"}
                        </td>

                        {/* Disbursed amount */}
                        {decode.instituteId ===
                          "9d5eca4b-54f7-42a7-8794-1413e00b462e" &&
                          decode.role === "institute_user" ? null : (
                          <td
                            style={{
                              fontSize: "14px",
                              width: "4em",
                              textAlign: "center",
                              color: "#667085",
                              fontFamily: "Inter",
                            }}
                          >
                            {item.disbursedAmount ? (
                              <>
                                &#8377;
                                {formatNumberWithCommas(
                                  Math.round(item.disbursedAmount)
                                )}
                              </>
                            ) : (
                              "-"
                            )}
                          </td>
                        )}

                        {/* Tenure */}
                        <td
                          style={{
                            fontSize: "14px",
                            width: "5em",
                            textAlign: "center",
                            color: "#667085",
                            fontFamily: "Inter",
                          }}
                        >
                          {item.tenure ? item.tenure : "-"}
                        </td>

                        {/* Fund source */}
                        {decode.role === "institute_user" ||
                          decode.role === "institute_admin" ||
                          decode.role === "channel_user" ? null : (
                          <td>
                            <span
                              style={{
                                fontSize: "14px",
                                width: "5em",
                                color: "#667085",
                                fontFamily: "Inter",
                                display: "inline-block",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {item.fundSource ? item.fundSource : "-"}
                            </span>
                          </td>
                        )}

                        {/* EMI date & amount for institute/channel roles */}
                        {decode.role === "institute_user" ||
                          decode.role === "institute_admin" ||
                          decode.role === "channel_user" ? (
                          <td
                            style={{
                              fontSize: "14px",
                              maxWidth: "1em",
                              textAlign: "center",
                              color: "#667085",
                              fontFamily: "Inter",
                            }}
                          >

                            {
                              item.emiFirstDate
                                ? item.fundSource === 'FIB'
                                  ? `${item.emiFirstDate.split('-')[1]}-${item.emiFirstDate.split('-')[0]}-${item.emiFirstDate.split('-')[2]}`
                                  : item.emiFirstDate
                                : "-"
                            }
                          </td>
                        ) : null}
                        {decode.role === "institute_user" ||
                          decode.role === "institute_admin" ||
                          decode.role === "channel_user" ? (
                          <td
                            style={{
                              fontSize: "14px",
                              width: "1em",
                              textAlign: "center",
                              color: "#667085",
                              fontFamily: "Inter",
                            }}
                          >
                            {item.emiAmount ? (
                              <>
                                &#8377;
                                {formatNumberWithCommas(item.emiAmount)}
                              </>
                            ) : (
                              "-"
                            )}
                          </td>
                        ) : null}

                        {/* UTR */}
                        <td
                          style={{
                            fontSize: "14px",
                            width: "8em",
                            color: "#667085",
                            fontFamily: "Inter",
                          }}
                        >
                          {item.disbursementUtr
                            ? item.disbursementUtr
                            : "-"}
                        </td>

                        {/* CRA */}
                        {decode?.role === "institute_user" ||
                          decode?.role === "institute_admin" ||
                          decode.role === "channel_user" ? null : (
                          <td
                            style={{
                              fontSize: "14px",
                              width: "8em",
                              color: "#667085",
                              fontFamily: "Inter",
                            }}
                          >
                            {item.cra ? item.cra : "-"}
                          </td>
                        )}
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>

              {/* Pagination + Rows-per-page */}
              {!usersearchinsstate && (
                <>
                  {totalFetchRows ? (
                    totalFetchRows <= 10 ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "10px",
                        }}
                      >
                        <div
                          style={{
                            textAlign: "center",
                            fontWeight: "bold",
                            fontFamily: "Inter",
                            fontSize: "1vw",
                            marginLeft: "10px",
                            marginBottom: "5px",
                          }}
                        >
                          Showing{" "}
                          {currentPage * rowsPerPage + 1 - rowsPerPage}-
                          {currentPage * rowsPerPage -
                            rowsPerPage +
                            tableData?.length}{" "}
                          records of {totalFetchRows} |
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <p style={{ fontWeight: "600" }}>
                            Rows Per Pages :
                          </p>
                          <div>
                            <span
                              onClick={() =>
                                handleRowsPerPageChange(15)
                              }
                              style={{
                                cursor: "pointer",
                                padding: "10px",
                                color:
                                  activePage === 15 ? "#D32028" : "black",
                                backgroundColor:
                                  activePage === 15 ? "#FFF2F3" : "",
                                borderRadius: "8px",
                              }}
                            >
                              15
                            </span>
                            <span
                              onClick={() =>
                                handleRowsPerPageChange(50)
                              }
                              style={{
                                cursor: "pointer",
                                padding: "10px",
                                color:
                                  activePage === 50 ? "#D32028" : "black",
                                backgroundColor:
                                  activePage === 50 ? "#FFF2F3" : "",
                                borderRadius: "8px",
                              }}
                            >
                              50
                            </span>
                            <span
                              onClick={() =>
                                handleRowsPerPageChange(100)
                              }
                              style={{
                                cursor: "pointer",
                                padding: "10px",
                                color:
                                  activePage === 100
                                    ? "#D32028"
                                    : "black",
                                backgroundColor:
                                  activePage === 100 ? "#FFF2F3" : "",
                                borderRadius: "8px",
                              }}
                            >
                              100
                            </span>
                            <span
                              onClick={() =>
                                handleRowsPerPageChange(500)
                              }
                              style={{
                                cursor: "pointer",
                                padding: "10px",
                                color:
                                  activePage === 500
                                    ? "#D32028"
                                    : "black",
                                backgroundColor:
                                  activePage === 500 ? "#FFF2F3" : "",
                                borderRadius: "8px",
                              }}
                            >
                              500
                            </span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "10px",
                        }}
                      >
                        <div
                          style={{
                            textAlign: "center",
                            fontWeight: "bold",
                            justifyContent: "space-between",
                            fontFamily: "Inter-Medium",
                            fontSize: "1vw",
                            marginLeft: "10px",
                            marginBottom: "5px",
                            marginRight: "10px",
                          }}
                        >
                          Showing{" "}
                          {currentPage * rowsPerPage + 1 - rowsPerPage}-
                          {currentPage * rowsPerPage -
                            rowsPerPage +
                            tableData?.length}{" "}
                          records of {totalFetchRows} |
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <p style={{ fontWeight: "600" }}>
                            Rows Per Pages :
                          </p>
                          <div>
                            <span
                              onClick={() =>
                                handleRowsPerPageChange(15)
                              }
                              style={{
                                cursor: "pointer",
                                padding: "10px",
                                color:
                                  activePage === 15 ? "#D32028" : "black",
                                backgroundColor:
                                  activePage === 15 ? "#FFF2F3" : "",
                                borderRadius: "8px",
                              }}
                            >
                              15
                            </span>
                            <span
                              onClick={() =>
                                handleRowsPerPageChange(50)
                              }
                              style={{
                                cursor: "pointer",
                                padding: "10px",
                                color:
                                  activePage === 50 ? "#D32028" : "black",
                                backgroundColor:
                                  activePage === 50 ? "#FFF2F3" : "",
                                borderRadius: "8px",
                              }}
                            >
                              50
                            </span>
                            <span
                              onClick={() =>
                                handleRowsPerPageChange(100)
                              }
                              style={{
                                cursor: "pointer",
                                padding: "10px",
                                color:
                                  activePage === 100
                                    ? "#D32028"
                                    : "black",
                                backgroundColor:
                                  activePage === 100 ? "#FFF2F3" : "",
                                borderRadius: "8px",
                              }}
                            >
                              100
                            </span>
                            <span
                              onClick={() =>
                                handleRowsPerPageChange(500)
                              }
                              style={{
                                cursor: "pointer",
                                padding: "10px",
                                color:
                                  activePage === 500
                                    ? "#D32028"
                                    : "black",
                                backgroundColor:
                                  activePage === 500 ? "#FFF2F3" : "",
                                borderRadius: "8px",
                              }}
                            >
                              500
                            </span>
                          </div>
                        </div>
                      </div>
                    )
                  ) : (
                    <div
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        fontFamily: "Inter",
                        fontSize: "14px",
                      }}
                    >
                      No Records
                    </div>
                  )}
                  <PaginationTable
                    startPage={currentPage}
                    rowsPerPage={rowsPerPage}
                    totalRows={totalFetchRows}
                    paginate={handlePageChange}
                    filterDateFrom={filterDateFrom}
                  />
                </>
              )}
            </>
          )}
        </CardBody>
    </Card>
  );
};

export default DisbursedTable;
